var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"cover","append":""}},[_c('div',{class:{
      'cover-image': true,
      active: _vm.active,
      default: !_vm.coverImage.src,
    }},[_c('transition',{attrs:{"name":"fade"}},[_c('img',{key:_vm.coverImage.src || 'default',attrs:{"src":_vm.coverImage.src || '/themes/sloan/img/design-spec-placeholder.png',"alt":_vm.coverImage.alt}})]),_vm._v(" "),_c('SloIcon',{attrs:{"name":"Images"}}),_vm._v(" "),_c('div',{staticClass:"overlay"},[_c('p',[_vm._v(_vm._s(_vm._f("t")('Cover Image')))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }